import CredentialsForm from "../../common/CredentialsForm";
import { useToken } from "../../common/TokenContext";
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import SyntaxHighlighter from "react-syntax-highlighter";
import ResponseStatusFooter from "../../common/ResponseStatusFooter";
import { defaultStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { EntityServices } from "../../Services/EntityServices";
import { IResponse, ISendRemittanceRequest } from "../../types/types";
import { GetSimpleLanguages } from "../../Services/app_helper";
import { END_POINTS_PATH } from "../../routes/paths";
import ShowSnackbar from "../../Services/snackbar";

interface props {
  codeBlackTitle: string;
  sendRemittanceObject: ISendRemittanceRequest;
}

interface codeBlockProps {
  Language: string;
  code: string;
}

export default function TrySendRemittance(props: props) {
  const { token } = useToken();
  const [copy, setCopy] = useState(false);

  const [loadButton, setLoadButton] = useState(false);

  const tryLanguages = GetSimpleLanguages(
    JSON.stringify(props.sendRemittanceObject, null, 2),
    END_POINTS_PATH.SendRemittance.slice(1)
  );

  const intializeCodeBlockProps: codeBlockProps = {
    Language: "json",
    code: tryLanguages.Csharp,
  };

  const [sampleCode, setCode] = useState(intializeCodeBlockProps);

  const [responseBody, setResponseBody] = useState(null as any);

  const [sendRemittance, SetSendRemittance] = useState(
    props.sendRemittanceObject
  );

  useEffect(() => {
    const tryLanguages = GetSimpleLanguages(
      JSON.stringify(sendRemittance, null, 2),
      END_POINTS_PATH.SendRemittance.slice(1)
    );

    if (sampleCode.Language.startsWith("Csharp"))
      setCode({ Language: "Csharp", code: tryLanguages.Csharp });
    else if (sampleCode.Language.startsWith("Java"))
      setCode({ Language: "Java", code: tryLanguages.Java });
    else if (sampleCode.Language.startsWith("JavaScript"))
      setCode({ Language: "JavaScript", code: tryLanguages.JavaScript });
    else if (sampleCode.Language.startsWith("PHP"))
      setCode({ Language: "PHP", code: tryLanguages.PHP });
    else if (sampleCode.Language.startsWith("Python"))
      setCode({ Language: "Python", code: tryLanguages.Python });
  }, [sendRemittance, sampleCode.Language]);

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement>,
    nestedObject?: string,
    subObject?: string
  ) => {
    const { name, value } = e.target;
    if (nestedObject === 'sender') {
      SetSendRemittance((prev) => ({
        ...prev,
        sender: {
          ...prev.sender,
          [name]: value,
        },
      }));
    } else if (nestedObject === 'receiver') {
      SetSendRemittance((prev) => ({
        ...prev,
        receiver: {
          ...prev.receiver,
          [name]: value,
        },
      }));
    } else {
      SetSendRemittance((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onLangaugeSelected = (language: string) => {
    if (language.startsWith("Csharp"))
      setCode({ Language: "Csharp", code: tryLanguages.Csharp });
    else if (language.startsWith("Java"))
      setCode({ Language: "Java", code: tryLanguages.Java });
    else if (language.startsWith("JavaScript"))
      setCode({ Language: "JavaScript", code: tryLanguages.JavaScript });
    else if (language.startsWith("PHP"))
      setCode({ Language: "PHP", code: tryLanguages.PHP });
    else if (language.startsWith("Python"))
      setCode({ Language: "Python", code: tryLanguages.Python });
  };

  const onTry = async () => {
    const service = new EntityServices<ISendRemittanceRequest>();
    setLoadButton(true);
    try {
      var response = await service.Post(
        END_POINTS_PATH.SendRemittance,
        sendRemittance,
        token
      );
      if (response?.statusCode === 200) {
        setLoadButton(false);
        setResponseBody(JSON.stringify(response.data));
        ShowSnackbar("Success", "primary");
      } else {
        setLoadButton(false);
        setResponseBody(JSON.stringify(response));
        ShowSnackbar("Try to renew the token by using GetToken endpoint", "danger");
      }
    } catch (error) {
      setLoadButton(false);
      ShowSnackbar("Failed", "danger");
    }
  };

  

  return (
    <>
      <div className="mt-5 me-4">
        <div className="row" style={{ backgroundColor: "#282C34" }}>
          <div className="d-flex flex-row justify-content-between bg-primary px-5 text-white text-xs py-2">
            <p className="my-auto">{props.codeBlackTitle}</p>
            <div className="btn-group mt-2 mb-2">
              <button
                type="button"
                className="btn btn-default dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Language <span className="caret"></span>
              </button>
              <ul className="dropdown-menu" role="menu">
                <li>
                  <Link to="#" onClick={() => onLangaugeSelected("Csharp")}>
                    <i className="fa fa-circle text-success"></i> C#
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={() => onLangaugeSelected("Java")}>
                    <i className="fa fa-circle text-success"></i> Java
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={() => onLangaugeSelected("PHP")}>
                    <i className="fa fa-circle text-success"></i> PHP
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={() => onLangaugeSelected("Python")}>
                    <i className="fa fa-circle text-success"></i> Python
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={() => onLangaugeSelected("JavaScript")}>
                    <i className="fa fa-circle text-success"></i> JavaScript
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <SyntaxHighlighter
            language={sampleCode.Language}
            style={defaultStyle}
            showLineNumbers={true}
            wrapLongLines={true}
            customStyle={{
              paddingTop: "15px",
              paddingBottom: "15px",
              fontWeight: 100,
              fontSize: 12,
              height: 370,
              width: "100%",
            }}
          >
            {sampleCode.code}
          </SyntaxHighlighter>
          <div className="d-flex flex-row justify-content-end px-5 text-white text-xs pb-2">
            {!copy ? (
              <button
                onClick={() => {
                  navigator.clipboard.writeText(sampleCode.code);
                  setCopy(true);
                  setTimeout(() => {
                    setCopy(false);
                  }, 3000);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  height={20}
                  width={22}
                >
                  <title>content-paste</title>
                  <path d="M11.5,1C12.71,1 13.72,1.86 13.95,3H17C18.66,3 20,4.34 20,6V19C20,20.66 18.66,22 17,22H6C4.34,22 3,20.66 3,19V6C3,4.34 4.34,3 6,3H9.05C9.28,1.86 10.29,1 11.5,1M12.91,3C12.71,2.42 12.15,2 11.5,2C10.85,2 10.29,2.42 10.09,3H12.91M6,4C4.9,4 4,4.9 4,6V19C4,20.1 4.9,21 6,21H17C18.1,21 19,20.1 19,19V6C19,4.9 18.1,4 17,4H16V7H7V4H6M8,4V6H15V4H8Z" />
                </svg>
                <span className="pl-2 text-white">Copy code</span>
              </button>
            ) : (
              <button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  height={20}
                  width={22}
                >
                  <title>check</title>
                  <path d="M18.9,8.1L9,18L4.05,13.05L4.76,12.34L9,16.59L18.19,7.39L18.9,8.1Z" />
                </svg>
                <span className="pl-2 text-white">Copy code</span>
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="card mt-5 shadow-sm border">
            <div className="card-header border-bottom d-flex flex-row justify-content-between">
              <div className="card-title">Response</div>
            </div>
            <div className="card-body p-3">
              {responseBody == null ? (
                <div className="text-start">
                  Click "Try it!" below to start a request and see the response here!
                </div>
              ) : (
                <pre className="text-start">
                  {JSON.stringify(JSON.parse(responseBody), null, 2)}
                </pre>
              )}
            </div>
            <div className="card-footer">
              <ResponseStatusFooter responseBody={responseBody} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 me-4">
        <div className="row">
          <div className="col-md-12">
            <div className="card shadow-sm border">
              <div className="card-header border-bottom">
                <h3 className="card-title">Body Parameters</h3>
              </div>
              <div className="card-body">
                <div className="row row-sm">
                  {/* ------------------------ requestUniqueId --------------------------- */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="requestUniqueId"
                      >
                        <span>Request Unique ID</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"requestUniqueId"}
                        placeholder="Request Unique ID"
                        type="text"
                        minLength={1}
                        maxLength={50}
                        value={sendRemittance.requestUniqueId}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ paymentMethod --------------------------- */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="paymentMethod"
                      >
                        <span>Payment Method</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <select
                        className="form-control"
                        name={"paymentMethod"}
                        value={sendRemittance.paymentMethod}
                        onChange={handleChange}
                      >
                        <option value="CASH">CASH</option>
                        <option value="BANK">BANK</option>
                        <option value="MOBILE">MOBILE</option>
                      </select>
                    </div>
                  </div>

                  {/* ------------------------ sender --------------------------- */}
                  <div className="col-md-12">
                    <div
                      className="panel-group1"
                      id="accordion11"
                      role="tablist"
                    >
                      <div className="card overflow-hidden mb-2 border-0">
                        <a
                          className="accordion-toggle panel-heading1 collapsed"
                          data-bs-toggle="collapse"
                          data-bs-parent="#accordion11"
                          href="#sender"
                          aria-expanded="false"
                        >
                          Sender{" "}
                          <span className="text-10 text-default">object</span>
                        </a>
                        <div
                          id="sender"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-expanded="false"
                        >
                          <div className="panel-body">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="id"
                                  >
                                    <span>ID</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"id"}
                                    placeholder="ID"
                                    type="text"
                                    minLength={1}
                                    maxLength={20}
                                    value={sendRemittance.sender.id}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="name"
                                  >
                                    <span>Name</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"name"}
                                    placeholder="Name"
                                    type="text"
                                    minLength={2}
                                    maxLength={100}
                                    value={sendRemittance.sender.name}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="phone"
                                  >
                                    <span>Phone</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"phone"}
                                    placeholder="Phone"
                                    type="text"
                                    minLength={7}
                                    maxLength={15}
                                    value={sendRemittance.sender.phone}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="city"
                                  >
                                    <span>City</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"city"}
                                    placeholder="City"
                                    type="text"
                                    minLength={2}
                                    maxLength={50}
                                    value={sendRemittance.sender.city}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="address"
                                  >
                                    <span>Address</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"address"}
                                    placeholder="Address"
                                    type="text"
                                    minLength={5}
                                    maxLength={200}
                                    value={sendRemittance.sender.address}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="country"
                                  >
                                    <span>Country</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"country"}
                                    placeholder="Country"
                                    type="text"
                                    minLength={2}
                                    maxLength={50}
                                    value={sendRemittance.sender.country}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="state"
                                  >
                                    <span>State</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"state"}
                                    placeholder="State"
                                    type="text"
                                    minLength={2}
                                    maxLength={50}
                                    value={sendRemittance.sender.state}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="postCode"
                                  >
                                    <span>Post Code</span>
                                    <span>&nbsp;</span>
                                    <span className="text-muted text-10">
                                      optional
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"postCode"}
                                    placeholder="Post Code"
                                    type="text"
                                    minLength={3}
                                    maxLength={10}
                                    value={sendRemittance.sender.postCode}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="nationality"
                                  >
                                    <span>Nationality</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"nationality"}
                                    placeholder="Nationality"
                                    type="text"
                                    minLength={2}
                                    maxLength={50}
                                    value={sendRemittance.sender.nationality}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="documentType"
                                  >
                                    <span>Document Type</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"documentType"}
                                    placeholder="Document Type"
                                    type="text"
                                    minLength={3}
                                    maxLength={20}
                                    value={sendRemittance.sender.documentType}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="documentNumber"
                                  >
                                    <span>Document Number</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"documentNumber"}
                                    placeholder="Document Number"
                                    type="text"
                                    minLength={5}
                                    maxLength={20}
                                    value={sendRemittance.sender.documentNumber}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="issueDate"
                                  >
                                    <span>Issue Date</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    placeholder="Issue Date"
                                    type="text"
                                    name={"issueDate"}
                                    value={sendRemittance.sender.issueDate}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="expireDate"
                                  >
                                    <span>Expire Date</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"expireDate"}
                                    placeholder="Expire Date"
                                    type="text"
                                    value={sendRemittance.sender.expireDate}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="dateOfBirth"
                                  >
                                    <span>Date Of Birth</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    placeholder="Date Of Birth"
                                    type="text"
                                    name={"dateOfBirth"}
                                    value={sendRemittance.sender.dateOfBirth}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="placeOfBirth"
                                  >
                                    <span>Place Of Birth</span>
                                    <span>&nbsp;</span>
                                    <span className="text-muted text-10">
                                      optional
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    placeholder="Place Of Birth"
                                    type="text"
                                    name={"placeOfBirth"}
                                    minLength={2}
                                    maxLength={50}
                                    value={sendRemittance.sender.placeOfBirth}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="senderType"
                                  >
                                    <span>Sender Type</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <select
                                    className="form-control"
                                    name={"senderType"}
                                    value={sendRemittance.sender.senderType}
                                    onChange={(e) => handleChange(e, 'sender')}
                                  >
                                    <option value="INDIVIDUAL">INDIVIDUAL</option>
                                    <option value="CORPORATE">CORPORATE</option>
                                    <option value="CHARITY">CHARITY</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ------------------------ receiver --------------------------- */}
                  <div className="col-md-12">
                    <div
                      className="panel-group1"
                      id="accordion12"
                      role="tablist"
                    >
                      <div className="card overflow-hidden mb-2 border-0">
                        <a
                          className="accordion-toggle panel-heading1 collapsed"
                          data-bs-toggle="collapse"
                          data-bs-parent="#accordion12"
                          href="#receiver"
                          aria-expanded="false"
                        >
                          Receiver{" "}
                          <span className="text-10 text-default">object</span>
                        </a>
                        <div
                          id="receiver"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-expanded="false"
                        >
                          <div className="panel-body">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="id"
                                  >
                                    <span>ID</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"id"}
                                    placeholder="ID"
                                    type="text"
                                    minLength={1}
                                    maxLength={20}
                                    value={sendRemittance.receiver.id}
                                    onChange={(e) => handleChange(e, 'receiver')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="destinationAgent"
                                  >
                                    <span>Destination Agent</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"destinationAgent"}
                                    placeholder="Destination Agent"
                                    type="text"
                                    minLength={3}
                                    maxLength={3}
                                    value={sendRemittance.receiver.destinationAgent}
                                    onChange={(e) => handleChange(e, 'receiver')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="name"
                                  >
                                    <span>Name</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"name"}
                                    placeholder="Name"
                                    type="text"
                                    minLength={2}
                                    maxLength={100}
                                    value={sendRemittance.receiver.name}
                                    onChange={(e) => handleChange(e, 'receiver')}
                                  />
                                </div>
                              </div>

                              <div className="col-md-12 col-xl-6">
                                <div className="form-group">
                                  <label
                                    className="form-label bolder"
                                    htmlFor="phone"
                                  >
                                    <span>Phone</span>
                                    <span>&nbsp;</span>
                                    <span className="text-danger text-10">
                                      required
                                    </span>
                                  </label>
                                  <input
                                    className="form-control"
                                    name={"phone"}
                                    placeholder="Phone"
                                    type="text"
                                    minLength={7}
                                    maxLength={15}
                                    value={sendRemittance.receiver.phone}
                                    onChange={(e) => handleChange(e, 'receiver')}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ------------------------ amount --------------------------- */}
                  <div className="col-md-12 col-xl-6">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="amount"
                      >
                        <span>Amount</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"amount"}
                        placeholder="Amount"
                        type="number"
                        min={0.01}
                        max={10000}
                        value={sendRemittance.amount}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ currencyCode --------------------------- */}
                  <div className="col-md-12 col-xl-6">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="currencyCode"
                      >
                        <span>Currency Code</span>
                        <span>&nbsp;</span>
                        <span className="text-muted text-10">
                          optional
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"currencyCode"}
                        placeholder="Currency Code"
                        type="text"
                        value={sendRemittance.currencyCode}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ CurrencyCode --------------------------- */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="CurrencyCode"
                      >
                        <span>Currency Code</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"CurrencyCode"}
                        placeholder="Currency Code"
                        type="text"
                        minLength={3}
                        maxLength={3}
                        value={sendRemittance.currencyCode}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ Purpose --------------------------- */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="Purpose"
                      >
                        <span>Purpose</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"Purpose"}
                        placeholder="Purpose"
                        type="text"
                        minLength={5}
                        maxLength={100}
                        value={sendRemittance.Purpose}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ payoutAmount --------------------------- */}
                  <div className="col-md-12 col-xl-6">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="payoutAmount"
                      >
                        <span>Payout Amount</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"payoutAmount"}
                        placeholder="Payout Amount"
                        type="number"
                        min={0.01}
                        max={10000}
                        value={sendRemittance.payoutAmount}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ commission --------------------------- */}
                  <div className="col-md-12 col-xl-6">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="commission"
                      >
                        <span>Commission</span>
                        <span>&nbsp;</span>
                        <span className="text-muted text-10">
                          optional
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"commission"}
                        placeholder="Commission Amount"
                        type="number"
                        min={0.01}
                        max={100000}
                        value={sendRemittance.commission || ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ narration --------------------------- */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="narration"
                      >
                        <span>Narration</span>
                        <span>&nbsp;</span>
                        <span className="text-muted text-10">
                          optional
                        </span>
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Narration"
                        rows={3}
                        name={"narration"}
                        maxLength={500}
                        value={sendRemittance.narration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* ------------------------ origRefNumber --------------------------- */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label
                        className="form-label bolder"
                        htmlFor="origRefNumber"
                      >
                        <span>Original Reference Number</span>
                        <span>&nbsp;</span>
                        <span className="text-danger text-10">
                          required
                        </span>
                      </label>
                      <input
                        className="form-control"
                        name={"origRefNumber"}
                        placeholder="Original Reference Number"
                        type="text"
                        minLength={1}
                        maxLength={50}
                        value={sendRemittance.origRefNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-3 text-end">
                  {token ? (
                    <div className="row row-sm my-4">
                      <div className="col-md-12 text-end">
                        <button
                          className="btn btn-primary"
                          disabled={loadButton}
                          onClick={onTry}
                        >
                          Try it!
                        </button>
                      </div>
                    </div>
                  ) : (
                    <p className="text-warning text-center my-4">
                      Try to get the token by using <Link to="/getToken" >GetToken</Link> endpoint to
                      enable the "Try it!" button.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
